import { render, staticRenderFns } from "./Naturaleza_contable.vue?vue&type=template&id=cb8912e8&lang=pug&"
import script from "./Naturaleza_contable.vue?vue&type=script&lang=js&"
export * from "./Naturaleza_contable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports